/* eslint-disable no-mixed-spaces-and-tabs */
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({

    autoComplete:{
        marginBottom:theme.spacing(4),
    },
    deviceSubheader: {
        color: theme.palette.amano.base.primary.main,
    },
    removeButton: {
        marginTop: 5,
    },
    select: {
        overflow: 'auto',
        overflowY: 'auto',
        overflowX: 'auto'
    },
    noDeviceItem: {
      color: theme.palette.error.main
    }
    // customBorder: {
    //       '& .MuiOutlinedInput-notchedOutline': {
    //         borderColor: '#d0d0d0',
    //         borderWidth: '2px',
    //         borderRadius: '8px',
    //     },
    //     '&:hover .MuiOutlinedInput-notchedOutline': {
    //       borderColor: '#b0b0b0',
    //     },
    //     '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    //       borderColor: '#808080',
    //     },
    //   },
}));
